export const getARDashboardAllowedClients = (): number[] => {
  // Runs on every menu render, so a malformed secret must not throw — that would
  // break the nav for every user. Fall back to an empty allow-list instead.
  const raw =
    ((import.meta.env || process.env)
      .VITE_AR_DASHBOARD_ALLOWED_CLIENTS as string) || '[]';
  try {
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed)
      ? parsed.filter((id): id is number => typeof id === 'number')
      : [];
  } catch {
    return [];
  }
};
